const AddressType = {
  HOME: 'HOME',
  WORK: 'WORK'
};

export default AddressType;
